<template>
  <layout-workflow content-background-color="light">
    <template>
      <div class="ma-3 app-version">
        <h3 class="mb-2">Application Information</h3>
        <v-card class="z1 mb-3">
          <v-card-title primary-title>
            <div>
              <h3 class="headline mb-0">VIPER</h3>
              <table class="subheading">
                <tr>
                  <th>Location</th>
                  <td>{{ appUrl }}</td>
                </tr>
                <tr>
                  <th>Version</th>
                  <td>{{ appVersion }}</td>
                </tr>
              </table>
            </div>
          </v-card-title>
        </v-card>

        <v-card class="z1 mb-3">
          <v-card-title primary-title>
            <div>
              <h3 class="headline mb-0">VIPER API</h3>
              <table class="subheading">
                <tr>
                  <th>Location</th>
                  <td>{{ apiUrl }}</td>
                </tr>
                <tr>
                  <th>Version</th>
                  <td>{{ api.version }}</td>
                </tr>
              </table>
            </div>
          </v-card-title>
        </v-card>

        <v-card v-if="showFeatureFlags" class="z1">
          <v-card-title primary-title>
            <div>
              <h3 class="headline mb-0">Feature Flags</h3>

              <table class="subheading">
                <tr v-for="(value, key) in featureFlags" :key="key">
                  <th>{{ key }}</th>
                  <td>{{ value }}</td>
                </tr>
              </table>
            </div>
          </v-card-title>
        </v-card>
      </div>
    </template>
  </layout-workflow>
</template>

<script>
import LayoutWorkflow from '@/components/layout/LayoutWorkflow'
import { BASE_HOST_URL } from '@/helpers/host-helper'
import { mapActions, mapState } from 'vuex'
import { GET_API_VERSION } from '@/store/mutation-types'
import { MyFeatureFlags } from '@/helpers/my-account-helper'
import { isFeatureOn } from '@/helpers/feature-flag-helper'

export default {
  components: { LayoutWorkflow },
  computed: {
    ...mapState({
      api: state => state.appVersion.api
    }),
    apiUrl() {
      return this.$appConfig.VUE_APP_VIPER_API_BASE_URL
    },
    appUrl() {
      return BASE_HOST_URL
    },
    appVersion() {
      return process.env.VERSION
    },
    featureFlags() {
      return MyFeatureFlags
    },
    showFeatureFlags() {
      return isFeatureOn('display-feature-flags')
    }
  },
  created() {
    this.GET_API_VERSION()
  },
  methods: {
    ...mapActions([GET_API_VERSION])
  }
}
</script>

<style lang="scss" scoped>
.app-version th {
  padding-right: 15px;
  text-align: right;
}

.app-version td {
  font-family: monospace;
}
</style>
